module.exports = __webpack_public_path__ + "img/dypitch-5-mobile.d063012a.jpg";